// Animated status line — used for the initial transcript load (with a "Loading…"
// label) and as the in-bubble typing indicator while a reply is pending (no
// label — dots only).
import React from "react";

import { HorizontalLoading } from "Cobalt/HorizontalLoading";
import type { IconProps } from "Common/Icon";

interface StatusIndicatorProps {
  label?: string;
  // Dot size — smaller in the chat bubble than in the full-panel loading state.
  size?: IconProps["size"];
}

export default function StatusIndicator({ label, size = "sm" }: StatusIndicatorProps) {
  // Empty title => HorizontalLoading shows the dots only (label stays sr-only).
  return <HorizontalLoading title={label ?? ""} isLoading dots={3} iconProps={{ size }} my={2} />;
}
